import {
  IGetMessengerNotificationsBotDetailsParams,
  IGetMessengerNotificationsBotDetailsResponse,
} from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { web3Api } from 'store/queries';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchSlackNotificationsBotDetails },
  useLazyFetchSlackNotificationsBotDetailsQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchSlackNotificationsBotDetails: build.query<
      IGetMessengerNotificationsBotDetailsResponse,
      IGetMessengerNotificationsBotDetailsParams | void
    >({
      queryFn: async params => {
        const service = MultiService.getService();

        const data = await service
          .getAccountingGateway()
          .getSlackNotificationsBotDetails(params ?? undefined);

        return { data };
      },
    }),
  }),
});

export const {
  selectDataWithFallbackCachedByParams: selectSlackNotificationsBotDetails,
  selectLoadingCachedByParams: selectSlackNotificationsBotDetailsLoading,
} = createQuerySelectors({
  endpoint: fetchSlackNotificationsBotDetails,
});
